// 交货计划
<template>
  <div style="height:100%">
    <SplitContainer2 style="height:100%" layout="horizontal" :split_setting="0.55">
      <template #table1>
        <TableMain name="one table" ref="OrderForecastDeliveryPlanTable1" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="true" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" @on_query="on_query" @current_changed="current_changed"
          :hb_table_class="'hb_table_forecasetDeliveryPlan_class1'" :isBusy="isBusy_table1" :table_height_adjust="-8"
          :loading_width="55">
          <template #query>
            {{ $t("common.label_forecast_order_num") }}：<el-input size="small" style="width: 150px" clearable
              v-model="ForecastSalesId"></el-input>
            {{ $t("common.provider") + $t("common.num") }}：<el-input size="small" style="width: 150px" clearable
              v-model="OrderAccountName">
            </el-input>
          </template>
        </TableMain>
      </template>
      <template #table2>
        <BaseContainer style="height:100%" class="one_table">
          <TableMain ref="ForecastDeliveryPlanRef" :fields="delivery_plan_fileds" :isBusy="isBusy_table2"
            :show_query_container="false" :title="table_title.title3" :date_picker_label="date_picker_label"
            :table_height_adjust="8" :show_filter="false" :show_pagination="show_pagination"
            @state_change="table3_state_change" :pager_count="5" :show_toolbar_button="[0, 0, 0, 0, 1]">
            <template #toolbar="">
              <el-button type="info" plain style="width: 55px" class="ml-2" @click="AddDelivery"><i
                  class="fa fa-plus"></i></el-button>
              <!-- <div style="display: inline-block">
                <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" accept=".xlsx" :on-exceed="exceed" :limit="1" :on-remove="remove" :http-request="uploadFile" :before-upload="beforeFileUpload" :show-file-list="false" :file-list="fileList" :on-success="successFile">
                  <el-button plain type="info" style="width: 55px" class="ml-2"><i class="iconfont icon-export-in"></i></el-button>
                </el-upload>
              </div>

              <el-tooltip content="模板下载" placement="top" effect="light">
                <el-button plain type="info" style="width: 55px" @click="downloadTemplate" class="ml-2"><i class="iconfont icon-template"></i></el-button>
              </el-tooltip> -->
            </template>
            <template #operation>
              <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="saveDelivery"
                :label="$t('common.save')" class="ml-2"></QueryButton>
            </template>
          </TableMain>
        </BaseContainer>
      </template>
    </SplitContainer2>
  </div>
</template>

<script>
// import axios from "axios"
import * as api from "@/shared/api"
// -- import * as _ from "lodash-es"
import { Split } from "view-design"
import "view-design/dist/styles/iview.css"
import XLSX from "xlsx"
import * as GuestController from "../../controllers/pages/GuestController"
import * as base_url from "../../shared/base_url"
import * as localStorageMgr from "../../shared/localStorageMgr"
import EntityEditor from "../components/base/EntityEditor"
import QueryButton from "../components/base/QueryButton"
import TestQueryPanel from "../components/base/TestQueryPanel"
import BaseContainer from "../components/BaseContainer"
import SplitContainer2 from "../components/container/SplitContainer2"
import TableDetail from "../components/table/TableDetail"
import TableMain from "../components/table/TableMain"

export default {
  name: "GuestVendSFDDeliveryPlan",
  components: {
    QueryButton,
    TableDetail,
    TableMain,
    TestQueryPanel,
    BaseContainer,
    EntityEditor,
    Split,
    SplitContainer2,
  },
  data() {
    return {
      guest_info: null,
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_forecast_dispatch",
        title3: "table_forecast_delivery_plan",
      },
      fields: GuestController.fields.sfd_fields,
      delivery_plan_fileds: GuestController.fields.sfd_delivery_plan_fields,
      isBusy_table1: false,
      isBusy_table2: false,
      isBusy_table3: false,
      show_pagination: false,
      ForecastSalesId: "",
      OrderAccount: "",
      OrderAccountName: "",
      selected1: null,
      selected2: null,
      selected3: null,
      fileList: [],
      base_url: base_url.base_url,
    }
  },
  created() {
    this.guest_info = JSON.parse(this.ls.get(localStorageMgr.data.guest_info))
  },
  deactivated() { },
  computed: {},

  methods: {
    downloadTemplate() {
      window.location.href =
        this.base_url + "/excel_template/" + "供应商交货计划导入模板20240802.xlsx"
    },
    //上传1个以上文件时弹窗提示错误
    exceed: function () {
      // this.$message.error("最多只能上传1个xls文件");
      this.msgToasts("最多只能上传1个xls文件!", "info")
    },
    //删除
    remove() { },
    successFile() {
      //this.isBusy_table3 = false
    },
    //解析excel
    async uploadFile(params) {
      this.isBusy_table3 = true
      let _this = this
      let _file = params.file
      let fileReader = new FileReader()
      fileReader.onload = (ev) => {
        try {
          let data = ev.target.result
          let workbook = XLSX.read(data, {
            type: "binary",
            cellDates: true,
          })
          let fields = []
          let listTable = []
          for (let sheet in workbook.Sheets) {
            if (sheet.indexOf("参考表") > -1) {
              continue
            }

            let sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], {
              defval: "",
            })
            if (sheetArray.length == 0) {
              continue
            }

            let _tmpModel = [
              {
                value: "PurchId",
                key: "采购订单号",
              },
              {
                value: "LineNumber",
                key: "采购订单行号",
              },
              {
                value: "OrderAccount",
                key: "供应商编号",
              },
              {
                value: "PurchQty",
                key: "采购数量",
              },
              {
                value: "DeliveryQty",
                key: "交货数量",
              },
              {
                value: "DeliveryDate",
                key: "交货日期",
              },
              {
                value: "Remark",
                key: "交货备注",
              },
            ]
            for (var _fm in _tmpModel) {
              let _field_model = { key: "", label: "" }
              let _key = _tmpModel[_fm].value
              let _label = _tmpModel[_fm].key
              _field_model.label = _label
              _field_model.key = _key
              fields.push(_field_model)
            }
            for (var i = 0, l = sheetArray.length; i < l; i++) {
              let _data = []
              for (var key in sheetArray[i]) {
                if (_.isDate(sheetArray[i][key])) {
                  sheetArray[i][key] = this.$date.addDays(
                    sheetArray[i][key],
                    1
                  )
                }
                _data.push({ key: key, value: sheetArray[i][key] })
              }
              let dif = _.differenceBy(_data, _tmpModel, "key")
              if (dif.length > 0) {
                // this.$message.warning("文件类型不正确！");
                this.msgToasts("文件类型不正确！!", "info")

                return
              }
            }
            listTable = sheetArray.map(function (o) {
              return {
                PurchId: o["采购订单号"],
                LineNumber: o["采购订单行号"],
                OrderAccount: o["供应商编号"],
                PurchQty: o["采购数量"],
                DeliveryQty: o["交货数量"],
                DeliveryDate: _this.$date.format(
                  new Date(o["交货日期"]),
                  "yyyy-MM-dd"
                ),
                Remark: o["交货备注"] ? o["交货备注"] : "",
              }
            })
            _this.$refs.ForecastDeliveryPlanRef.SetData(listTable)
            if (
              _this.$refs.ForecastDeliveryPlanRef.my_data &&
              _this.$refs.ForecastDeliveryPlanRef.my_data.length > 50
            ) {
              _this.show_pagination = true
            }
          }
        } catch (e) {
          console.log(e)
          // this.$message.warning("文件类型不正确！");
          this.msgToasts("文件类型不正确！!", "info")

          this.isBusy_table3 = false
        }
      }
      fileReader.readAsBinaryString(_file)
      this.isBusy_table3 = false
      this.fileList = []
    },
    //before上传
    beforeFileUpload() { },

    //状态改变
    table3_state_change(data, cb) {
      let _this = this
      if (data.state === "deleted") {
        this.msgModal(this.$t("notify.is_deleted")).then(async (t) => {
          if (t) {
            let query_settings = []
            let _del_list = data.selected_items
            if (_del_list && _del_list.length > 0) {
              _.each(_del_list, (t) => {
                let _m = new FormData()
                _m.append("id", t.id)
                _m.append("DeliveryQty", t.DeliveryQty)
                _m.append("DeliveryDate", this.formatDate(t.DeliveryDate))
                _m.append("Remark", t.Remark)
                _m.append("is_deleted", 1)
                query_settings.push({
                  url: api.pub_url("save", this.guest_info.idx, "pub_update_forecast_dispatch_delivery_plan"),
                  parameters: _m,
                  method: "post",
                })
              })
              let _result = await api.query_all_async(query_settings)
              if (_result && _result.length > 0) {
                this.$refs.ForecastDeliveryPlanRef.RemoveItems(data.selected_items)
                this.msgToasts(this.$t("notify.action_successfully"), "success")
                cb(true)
              } else {
                this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
                cb(false)
              }
            }
          }
        })
      }
    },

    //保存交货计划
    async saveDelivery(cb) {
      let _this = this
      if (this.$refs.ForecastDeliveryPlanRef.my_data.length == 0) {
        cb(true)
        return
      }
      //数据检测
      let _is_check_ok = this.validData(this.$refs.ForecastDeliveryPlanRef.my_data)
      if (!_is_check_ok) {
        cb(true)
        return
      }
      //新增or修改
      let query_settings = []
      let data = _.cloneDeep(this.$refs.ForecastDeliveryPlanRef.my_data)
      let _line_m = this.$refs.OrderForecastDeliveryPlanTable1.GetCurrentItem()
      _.each(data, (t) => {
        if (_.isInteger(t.id)) {
          let _m = new FormData()
          _m.append("id", t.id)
          _m.append("DeliveryQty", t.DeliveryQty)
          _m.append("DeliveryDate", this.formatDate(t.DeliveryDate))
          _m.append("Remark", t.Remark)
          _m.append("is_deleted", t.is_deleted)
          query_settings.push({
            url: api.pub_url("save", this.guest_info.idx, "pub_update_forecast_dispatch_delivery_plan"),
            parameters: _m,
            method: "post",
          })
        } else {
          let _m = new FormData()
          _m.append("ForecasetDispatchId", _line_m.id)
          _m.append("DeliveryQty", t.DeliveryQty)
          _m.append("DeliveryDate", this.formatDate(t.DeliveryDate))
          _m.append("Remark", t.Remark)
          query_settings.push({
            url: api.pub_url("save", this.guest_info.idx, "pub_insert_forecast_dispatch_delivery_plan"),
            parameters: _m,
            method: "post",
          })
        }
      })
      let _result = await api.query_all_async(query_settings)
      if (_result && _result.length > 0) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        await this.excuteSearchDeliveryPlan(_line_m)
        cb(true)
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
        cb(false)
      }
    },
    //数据检测
    validData(data) {
      ///检查是否重复交货日期
      let _is_qty_ok = true
      _.each(data, (t) => {
        t.DeliveryDate = this.$date.format(
          new Date(this.formatDate(t.DeliveryDate)),
          "yyyy-MM-dd"
        )
        if (
          t.DeliveryQty == "" ||
          _.isNull(t.DeliveryQty) ||
          parseFloat(t.DeliveryQty) == 0
        ) {
          _is_qty_ok = false
        }
      })
      if (!_is_qty_ok) {
        this.msgToasts(this.$t("notify.not_pcs"), "info")
        return _is_qty_ok
      }
      let _cd = _.groupBy(data, "DeliveryDate")
      let _is_repeat = false
      for (var i in _cd) {
        if (_cd[i].length > 1) {
          _is_repeat = true
          break
        }
      }
      if (_is_repeat) {
        this.msgToasts(this.$t("notify.delivery_date_exist"), "info")
        return !_is_repeat
      }
      //按单号拆分
      let _is_dis_qty_ok = true
      let disItem = this.$refs.OrderForecastDeliveryPlanTable1.GetCurrentItem()
      if (disItem) {
        let sumDeliveryQty = _.sumBy(data, "DeliveryQty")
        if (sumDeliveryQty > disItem.qty) {
          this.msgToasts(this.$t("notify.plan_pcs_not_more_dispatch_pcs"), "info")
          _is_dis_qty_ok = false
        }
      }

      return _is_dis_qty_ok
    },

    //新增交期计划
    AddDelivery() {
      let dispatch_selected = this.$refs.OrderForecastDeliveryPlanTable1.GetCurrentItem()
      if (dispatch_selected && !_.isNull(dispatch_selected)) {
        this.DeliveryChoose(dispatch_selected)
      } else {
        this.msgToasts(this.$t("notify.not_selected_data"), "warning")
        return
      }
    },
    async DeliveryChoose(disItem) {
      let _this = this
      let _append_items = []

      let _m = _.cloneDeep(GuestController.dataDeliveryForm)
      _m.id = ""
      _m.ForecasetDispatchId = disItem.id
      _m.AccountNum = disItem.AccountNum
      _m.AccountNumName = disItem.SEI_Name
      _m.DeliveryQty = 0
      _m.DeliveryDate = _this.$date.format(new Date(), "yyyy-MM-dd")
      _m.Remark = ""

      _append_items.push(_m)

      if (this.$refs.ForecastDeliveryPlanRef.my_data.length > 0) {
        this.$refs.ForecastDeliveryPlanRef.AppendItems(_append_items)
      } else {
        this.$refs.ForecastDeliveryPlanRef.SetData(_append_items)
      }
    },
    ///查询
    async on_query(set_data, date_range) {
      this.isBusy_table1 = true
      this.selected2 = null
      this.selected1 = null
      set_data([])
      let _fromDate = "",
        _toDate = ""
      let _params = { pub_token: this.ls.get("pub_guest_token"), }
      if (this.ForecastSalesId != "") {
        _params.ForecastSalesId = this.ForecastSalesId
      }
      if (this.OrderAccountName != "") {
        _params.OrderAccountName = this.OrderAccountName
      }
      if (
        !_.isNull(date_range) &&
        this.ForecastSalesId == "" &&
        this.OrderAccountName == ""
      ) {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _params["fromDate"] = _fromDate
        _params["toDate"] = _toDate
      }
      let _result = await api.query_async({
        url: api.pub_url("get", this.guest_info.idx, "pub_get_delivery_forecast_dispatch"),
        parameters: _params,
        method: "get",
      })
      if (
        _result &&
        _result[0] &&
        _result[0].result &&
        _result[0].result.data &&
        _result[0].result.data.Result &&
        _result[0].result.data.Result[0]
      ) {
        set_data(_.orderBy(_result[0].result.data.Result[0], ["id"], ["desc"]))
      }

      this.isBusy_table1 = false
    },

    async current_changed(old, current) {
      if (_.isNull(current)) {
        this.$refs.ForecastDeliveryPlanRef.SetData([])
        return
      }
      this.isBusy_table2 = true
      await this.excuteSearchDeliveryPlan(current)
      this.isBusy_table2 = false
    },

    async excuteSearchDeliveryPlan(current) {
      let _result = await api.query_async({
        url: api.pub_url("get", this.guest_info.idx, "pub_get_forecast_dispatch_delivery_plan"),
        parameters: { pub_token: this.ls.get("pub_guest_token"), ForecasetDispatchId: current.id },
        method: "get",
      })
      if (
        _result &&
        _result[0] &&
        _result[0].result &&
        _result[0].result.data &&
        _result[0].result.data.Result &&
        _result[0].result.data.Result[0]
      ) {
        this.$refs.ForecastDeliveryPlanRef.SetData(_.orderBy(_result[0].result.data.Result[0], ["id"], ["asc"]))
      }
    }

  },
}
</script>
<style>
.hb_table_forecasetDeliveryPlan_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 120rem;
}

.hb_table_forecasetDeliveryPlan_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 80rem;
}
</style>

<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
